import { HtmlDisplayTab } from './HtmlDisplayTab';

export const TrivyReportTab = () => {
  return (
    <HtmlDisplayTab
      annotationKey="trivy.security-report"
      title="Trivy Security Report"
      description="Security vulnerability and compliance analysis for this component. This report is generated by Trivy and shows security vulnerabilities, compliance issues, and other security-related findings in the codebase."
      height={800}
      showSourceLink
    />
  );
}; 